import { Alert, Box, Card, Heading, SimpleGrid, Skeleton, VStack } from '@chakra-ui/react';
import { useFocusedBranchContext } from '@packages/core/branch/focused-branch-context';
import { useTranslate } from '@tolgee/react';
import { useEffect, useState } from 'react';
import { DateRange } from '../../common/reservation-analytic-service';
import SkeletonCard from '../../common/skeleton-card';
import MetricCard from '../../reservation/component/metric-card';
import useGetCustomerSummaryAppointmentReport from '../logic/use-get-customer-summary-appointment-report';

export default function NailCustomerSummaryReportCard(props: { dateRange: DateRange }) {
  const branch = useFocusedBranchContext();
  const { t } = useTranslate();

  const [dateRange, setDateRange] = useState<DateRange>({
    startDate: props.dateRange.startDate,
    endDate: props.dateRange.endDate,
  });

  useEffect(() => {
    setDateRange({
      startDate: props.dateRange.startDate,
      endDate: props.dateRange.endDate,
    });
  }, [props.dateRange]);

  const { analytics, isLoading, error } = useGetCustomerSummaryAppointmentReport(branch.branch?.id ?? '', dateRange);

  if (isLoading) {
    return (
      <VStack gap={4} align="stretch">
        <Skeleton height="40px" />
        <SimpleGrid columns={{ base: 1, md: 2 }} gap={6}>
          {Array.from({ length: 2 }).map((_, index) => (
            <SkeletonCard key={index} />
          ))}
        </SimpleGrid>
      </VStack>
    );
  }

  if (error) {
    return (
      <Alert.Root status="error" borderRadius="md">
        <Box>
          <Alert.Title>Error loading customer summary!</Alert.Title>
          <Alert.Description>{error.message}</Alert.Description>
        </Box>
      </Alert.Root>
    );
  }

  if (!analytics) {
    return (
      <Alert.Root status="info" borderRadius="md">
        <Alert.Title>No data available</Alert.Title>
      </Alert.Root>
    );
  }

  const { current, trends } = analytics;

  return (
    <Card.Root>
      <Card.Header>
        <Card.Title>
          <Heading fontWeight={'semibold'} fontSize="xl" color="gray.900">
            {t('appointment.report.customerSummary', 'Customer Summary')}
          </Heading>
        </Card.Title>
      </Card.Header>
      <Card.Body p={0}>
        <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
          <MetricCard
            title={t('appointment.report.customerSummary.metric.newCustomers.title', 'Khách mới')}
            value={current.newCustomers}
            trend={trends.newCustomers}
            subtitle={t('appointment.report.customerSummary.metric.newCustomers.subtitle', 'New customers')}
          />

          <MetricCard
            title={t('appointment.report.customerSummary.metric.returningCustomers.title', 'Khách quay lại')}
            value={current.returningCustomers}
            trend={trends.returningCustomers}
            subtitle={t('appointment.report.customerSummary.metric.returningCustomers.subtitle', 'Returning customers')}
          />
        </SimpleGrid>
      </Card.Body>
    </Card.Root>
  );
}
